import React from 'react';

import { AssetNotFound } from '../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/AssetNotFound';
import { AssetsLoading } from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { ProductErrorListing } from '../ProductErrorListing';

export interface ListEmptyProps {
  hasError: boolean;
  isLoading: boolean;
  hasData: boolean;
  ProductItemLoading: React.FC;
}

export const ListEmpty: React.FC<ListEmptyProps> = ({
  hasError,
  hasData,
  isLoading,
  ProductItemLoading,
}) => {
  if (hasError) {
    return <ProductErrorListing />;
  }

  if (!isLoading && !hasData) {
    return <AssetNotFound />;
  }

  return <AssetsLoading ProductItemLoading={ProductItemLoading} quantity={5} />;
};
